import React from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  InputField,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@jem-open/jem-ui";

export interface CreateSiteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  regions: { id: string; name: string }[];
  regionId: string;
  onRegionIdChange: (id: string) => void;
  name: string;
  onNameChange: (name: string) => void;
  onConfirm: () => void;
}

/** Create a new Site within a Region. Used on the Sites & Regions overview. */
export const CreateSiteDialog: React.FC<CreateSiteDialogProps> = ({
  open,
  onOpenChange,
  regions,
  regionId,
  onRegionIdChange,
  name,
  onNameChange,
  onConfirm,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Create new Site</DialogTitle>
        <DialogDescription>
          Pick the Region this Site belongs to, then name it. You&apos;ll be
          able to configure settings, geofence, and Rosters from the Site page
          after creating it.
        </DialogDescription>
      </DialogHeader>
      <div className="mt-md space-y-md">
        <div className="space-y-xxs">
          <Label>Region</Label>
          <Select value={regionId} onValueChange={onRegionIdChange}>
            <SelectTrigger>
              <SelectValue placeholder="Select a Region" />
            </SelectTrigger>
            <SelectContent>
              {regions.map((r) => (
                <SelectItem key={r.id} value={r.id}>
                  {r.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-xxs">
          <Label>Site name</Label>
          <InputField
            value={name}
            onChange={(e) => onNameChange(e.target.value)}
            placeholder="e.g. Pretoria Office"
          />
        </div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>
          Cancel
        </Button>
        <Button
          variant="default"
          disabled={!regionId || !name.trim()}
          onClick={onConfirm}
        >
          Create Site
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default CreateSiteDialog;
